import Quill from 'quill'

/** 工具栏下拉顺序：常用像素 + 默认 + Quill 内置三档 */
export const QUILL_FONT_SIZE_OPTIONS = [
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
  '21px',
  '22px',
  '24px',
  '26px',
  '28px',
  '32px',
  '36px',
  false,
  'small',
  'large',
  'huge'
]

const PX_SIZES = QUILL_FONT_SIZE_OPTIONS.filter((v) => typeof v === 'string' && v.endsWith('px'))

let registered = false

/**
 * 扩展 Quill 默认 size 白名单（仅 small/large/huge），加入多档像素字号。
 * 须在首个编辑器实例创建前调用一次。
 */
export function registerQuillExtendedFontSize () {
  if (registered) return
  registered = true
  const Parchment = Quill.import('parchment')
  const whitelist = [...new Set([...PX_SIZES, 'small', 'large', 'huge'])]
  const ExtendedSizeClass = new Parchment.Attributor.Class('size', 'ql-size', {
    scope: Parchment.Scope.INLINE,
    whitelist
  })
  Quill.register(ExtendedSizeClass, true)
}
